import { GetStaticProps } from "next";
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageOgTitle: "장례 예상 비용, 장례 견적 알아보기- [우리가 찾던 장례전문가, 고이]",
      pageDescription:
        "맞춤형 장례 비용을 알려드립니다. 장례식장 추천, 지역별 장례 비용 최저가, 장례식 비용 예상 견적 알아보기",
      pageKeywords:
        "후불제, 후불제상조, 선불제, 선불제상조, 후불제상조 선불제상조, 장례, 장례상담, 상조, 상조순위, 상조 기준, 상조차이, 상조비교, 상조회사, 상조회사서비스, 보람상조, 프리드라이프, 예다함",
      pageOgDescription:
        "맞춤형 장례 비용을 알려드립니다. 장례식장 추천, 지역별 장례 비용 최저가, 장례식 비용 예상 견적 알아보기",
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/prepare-1-1.png`,
    },
  };
};
export { MatchRequestContainer as default } from "containers/MatchContainer";
